module.exports = __webpack_public_path__ + "media/frostivus_frost.6c5d6c01.webm";